import { useMemo } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import * as events from 'src/lib/events';
import { PAGES, useTrackingEvent } from 'src/services/useTrackingEvent';

export const useBriefUpdateEvent = () => {
  const trackingEvent = useTrackingEvent();

  const trackBriefUpdate = useDebouncedCallback(() => {
    trackingEvent(events.PROJECT.briefUpdate, { page: PAGES.editor });
  }, 1000);

  return useMemo(
    () => ({
      trackBriefUpdate,
    }),
    [trackBriefUpdate]
  );
};
